import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from '../utils/pipes/safe-style.pipe';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { EnumToArrayPipe } from '../utils/pipes/enum-to-array.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ReplacementMissingTranslationHandler } from '../utils/translate/missing.translation.handler';
import { RootLangDirective } from '../utils/directives/root-lang.directive';
import { environment } from 'src/environments/environment';

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  //https://github.com/ngx-translate/core/issues/1005
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + environment.build);
}

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            },
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: ReplacementMissingTranslationHandler },
            useDefaultLang: true
        }),
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        SafePipe,
        EnumToArrayPipe,
        RootLangDirective,
    ],
    exports: [
        TranslateModule,
        HttpClientModule,
        SafePipe,
        EnumToArrayPipe,
        FormsModule,
        ReactiveFormsModule,
        RootLangDirective,
    ]
})
export class CoreModule { }
